export const ArrowRightIcon = () => {
  return <svg height="512" viewBox="0 0 494.942 494.942" width="512" data-sentry-element="svg" data-sentry-component="ArrowRightIcon" data-sentry-source-file="arrow-right.tsx">
      <path d="m35.353 0 424.236 247.471-424.236 247.471z" data-sentry-element="path" data-sentry-source-file="arrow-right.tsx" />
    </svg>;
};